import type { LandingPageConfigOptions } from "landing/objects/LandingPageConfig";

export const LandingPageTemplate16: LandingPageConfigOptions = {
  consentAge: 19,
};
